// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file artifacts/store/v1/store_service.proto (package artifacts.store.v1, syntax proto3)
/* eslint-disable */

import { OrgArtifactStoreService } from "./store_service_pb";

/**
 * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.GetArtifactPreviewUrl
 */
export const getArtifactPreviewUrl = OrgArtifactStoreService.method.getArtifactPreviewUrl;

/**
 * GetArtifactDownloadUrl returns a presigned link that saves the file rather
 * than opening it. Separate from GetArtifactPreviewUrl because the only
 * difference is the object's content-disposition, and the two are wanted in
 * different places -- the bytes never pass through our servers either way.
 *
 * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.GetArtifactDownloadUrl
 */
export const getArtifactDownloadUrl = OrgArtifactStoreService.method.getArtifactDownloadUrl;

/**
 * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.UploadArtifact
 */
export const uploadArtifact = OrgArtifactStoreService.method.uploadArtifact;

/**
 * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.RetryArtifact
 */
export const retryArtifact = OrgArtifactStoreService.method.retryArtifact;

/**
 * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.DeleteOrgArtifact
 */
export const deleteOrgArtifact = OrgArtifactStoreService.method.deleteOrgArtifact;

/**
 * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.DownloadOrgArtifact
 */
export const downloadOrgArtifact = OrgArtifactStoreService.method.downloadOrgArtifact;
